<template>
  <KCard h-icon="md-eye" htitle="Unique views">
    <div slot="content" >
      <Row class="text-center">
        <i-col :xs="2" :sm="4" :md="6" :lg="8">
          <p><Icon type="ios-stats" size="22" color="#ccc"/></p>
          <h2 v-html="(views && views[0])? views[0]:0"></h2>
          <p>Last 24 hours</p>
        </i-col>
        <i-col :xs="20" :sm="16" :md="12" :lg="8">
          <p><Icon type="ios-stats" size="22" color="#ccc"/></p>
          <h2 v-html="(views && views[1])? views[1]:0"></h2>
          <p>Last 7 days</p>
        </i-col>
        <i-col :xs="2" :sm="4" :md="6" :lg="8">
          <p><Icon type="ios-stats" size="22" color="#ccc"/></p>
          <h2 v-html="(views && views[2])? views[2]:0"></h2>
          <p>Last 30 days</p>
        </i-col>
      </Row>
    </div>
  </KCard>
</template>

<script>
import KCard from '@/components/ui/Card'

export default {
  components: {
    KCard
  },

  props: {
    views: {
      type: Array,
      default: () => [0, 0, 0]
    }
  }
}
</script>
